import { EXECUTION_STATUSES, TASK_STATUSES, TASK_TYPES } from '../shared/constants';

export const mockTasks = [
  {
    taskId: '550e8400-e29b-41d4-a716-446655440001',
    name: 'v5.64.0',
    type: TASK_TYPES.FW_UPDATE,
    status: TASK_STATUSES.ACTIVE,
    executionStatus: EXECUTION_STATUSES.SUCCEEDED,
    lastReported: '2026-02-08T14:30:00Z',
    createdAt: '2026-02-05T09:15:00Z',
    steps: [
      {
        stepId: 1,
        name: 'Download Firmware',
        type: 'download',
        status: EXECUTION_STATUSES.SUCCEEDED,
        description: 'Download firmware package from CDN',
      },
      {
        stepId: 2,
        name: 'Verify Checksum',
        type: 'verify',
        status: EXECUTION_STATUSES.SUCCEEDED,
        description: 'Verify firmware package integrity',
      },
      {
        stepId: 3,
        name: 'Apply Update',
        type: 'apply',
        status: EXECUTION_STATUSES.SUCCEEDED,
        description: 'Apply firmware update and reboot edge controller',
      },
    ],
    definition: {
      taskId: '550e8400-e29b-41d4-a716-446655440001',
      name: 'v5.64.0',
      type: 'FW_UPDATE',
      targetEdgeControllerId: 'EC-HW-2024-001-A',
      metadata: {
        version: '5.64.0',
        releaseNotes: 'Security patches and performance improvements',
      },
      actions: [
        {
          type: 'download_firmware',
          parameters: {
            firmwareUrl: 'https://cdn.example.com/fw/v5.64.0.bin',
            checksum: 'sha256:abc123...',
          },
        },
        {
          type: 'apply_firmware',
          parameters: {
            rebootAfter: true,
            timeout: 600,
          },
        },
      ],
    },
  },
  {
    taskId: '550e8400-e29b-41d4-a716-446655440002',
    name: 'Assign to Downtown Hub',
    type: TASK_TYPES.ASSIGN_TO_PLAZA,
    status: TASK_STATUSES.ACTIVE,
    executionStatus: EXECUTION_STATUSES.SUCCEEDED,
    lastReported: '2026-02-07T11:45:00Z',
    createdAt: '2026-02-06T08:30:00Z',
    steps: [
      {
        stepId: 1,
        name: 'Validate Plaza',
        type: 'validate',
        status: EXECUTION_STATUSES.SUCCEEDED,
        description: 'Validate plaza availability and configuration',
      },
      {
        stepId: 2,
        name: 'Update Edge Controller Config',
        type: 'config_update',
        status: EXECUTION_STATUSES.SUCCEEDED,
        description: 'Update edge controller configuration with plaza details',
      },
      {
        stepId: 3,
        name: 'Sync Chargers',
        type: 'sync',
        status: EXECUTION_STATUSES.SUCCEEDED,
        description: 'Synchronize charger list and status',
      },
    ],
    definition: {
      taskId: '550e8400-e29b-41d4-a716-446655440002',
      name: 'Assign to Downtown Hub',
      type: 'ASSIGN_TO_PLAZA',
      targetEdgeControllerId: 'EC-HW-2024-002-B',
      metadata: {
        plazaId: 'plaza-002',
        plazaName: 'Airport Plaza Station',
      },
      actions: [
        {
          type: 'validate_plaza',
          parameters: {
            plazaId: 'plaza-002',
          },
        },
        {
          type: 'update_device_config',
          parameters: {
            plazaId: 'plaza-002',
            plazaName: 'Airport Plaza Station',
          },
        },
        {
          type: 'sync_chargers',
          parameters: {
            timeout: 300,
          },
        },
      ],
    },
  },
  {
    taskId: '550e8400-e29b-41d4-a716-446655440003',
    name: 'Config Update - Peak Hours',
    type: TASK_TYPES.CONFIG_UPDATE,
    status: TASK_STATUSES.ACTIVE,
    executionStatus: EXECUTION_STATUSES.IN_PROGRESS,
    lastReported: '2026-02-10T13:20:00Z',
    createdAt: '2026-02-09T16:00:00Z',
    steps: [
      {
        stepId: 1,
        name: 'Backup Current Config',
        type: 'backup',
        status: EXECUTION_STATUSES.SUCCEEDED,
        description: 'Create backup of current configuration',
      },
      {
        stepId: 2,
        name: 'Apply New Config',
        type: 'apply_config',
        status: EXECUTION_STATUSES.IN_PROGRESS,
        description: 'Apply updated configuration parameters',
      },
      {
        stepId: 3,
        name: 'Validate Config',
        type: 'validate',
        status: EXECUTION_STATUSES.QUEUED,
        description: 'Validate new configuration and restart services',
      },
    ],
    definition: {
      taskId: '550e8400-e29b-41d4-a716-446655440003',
      name: 'Config Update - Peak Hours',
      type: 'CONFIG_UPDATE',
      targetEdgeControllerId: 'EC-HW-2024-003-G',
      metadata: {
        configVersion: '2.4.9-peak-v1',
        appliedAt: '2026-02-10T13:20:00Z',
      },
      configuration: {
        loadBalancing: {
          mode: 'peak_hours',
          maxLoadPerCharger: 75,
          balanceInterval: 30,
        },
        monitoring: {
          telemetryInterval: 15,
          alertThreshold: 85,
        },
      },
    },
  },
  {
    taskId: '550e8400-e29b-41d4-a716-446655440004',
    name: 'Unassign from Shopping Mall',
    type: TASK_TYPES.UNASSIGN_FROM_PLAZA,
    status: TASK_STATUSES.ACTIVE,
    executionStatus: EXECUTION_STATUSES.FAILED,
    lastReported: '2026-02-08T15:10:00Z',
    createdAt: '2026-02-08T14:00:00Z',
    steps: [
      {
        stepId: 1,
        name: 'Pause Chargers',
        type: 'pause',
        status: EXECUTION_STATUSES.SUCCEEDED,
        description: 'Put all chargers in pause mode',
      },
      {
        stepId: 2,
        name: 'Clear Plaza Assignment',
        type: 'clear_assignment',
        status: EXECUTION_STATUSES.FAILED,
        description: 'Clear plaza assignment from edge controller',
      },
    ],
    definition: {
      taskId: '550e8400-e29b-41d4-a716-446655440004',
      name: 'Unassign from Shopping Mall',
      type: 'UNASSIGN_FROM_PLAZA',
      targetEdgeControllerId: 'EC-HW-2024-004-D',
      metadata: {
        plazaId: 'plaza-004',
        reason: 'Edge controller maintenance',
      },
      actions: [
        {
          type: 'pause_chargers',
          parameters: {
            timeout: 120,
          },
        },
        {
          type: 'clear_plaza_assignment',
          parameters: {
            preserveHistory: true,
          },
        },
      ],
    },
  },
  {
    taskId: '550e8400-e29b-41d4-a716-446655440005',
    name: 'Handover to Valeo',
    type: TASK_TYPES.CHANGE_CUSTOMER,
    status: TASK_STATUSES.ACTIVE,
    executionStatus: EXECUTION_STATUSES.SUCCEEDED,
    lastReported: '2026-02-07T10:30:00Z',
    createdAt: '2026-02-06T12:00:00Z',
    steps: [
      {
        stepId: 1,
        name: 'Validate Customer',
        type: 'validate',
        status: EXECUTION_STATUSES.SUCCEEDED,
        description: 'Validate new customer credentials and access',
      },
      {
        stepId: 2,
        name: 'Update Ownership',
        type: 'ownership',
        status: EXECUTION_STATUSES.SUCCEEDED,
        description: 'Update edge controller ownership and permissions',
      },
      {
        stepId: 3,
        name: 'Sync Customer Data',
        type: 'sync',
        status: EXECUTION_STATUSES.SUCCEEDED,
        description: 'Synchronize customer-specific data and settings',
      },
    ],
    definition: {
      taskId: '550e8400-e29b-41d4-a716-446655440005',
      name: 'Handover to Valeo',
      type: 'CHANGE_CUSTOMER',
      targetEdgeControllerId: 'EC-HW-2024-005-E',
      metadata: {
        fromCustomerId: null,
        toCustomerId: 'valeo',
        toCustomerName: 'Valeo',
      },
      actions: [
        {
          type: 'validate_customer',
          parameters: {
            customerId: 'valeo',
          },
        },
        {
          type: 'update_ownership',
          parameters: {
            customerId: 'valeo',
            permissions: ['read', 'write', 'execute'],
          },
        },
        {
          type: 'sync_customer_data',
          parameters: {
            timeout: 300,
          },
        },
      ],
    },
  },
  {
    taskId: '550e8400-e29b-41d4-a716-446655440006',
    name: 'v5.63.5',
    type: TASK_TYPES.FW_UPDATE,
    status: TASK_STATUSES.ACTIVE,
    executionStatus: EXECUTION_STATUSES.CANCELED,
    lastReported: '2026-02-05T18:00:00Z',
    createdAt: '2026-02-05T16:00:00Z',
    steps: [
      {
        stepId: 1,
        name: 'Download Firmware',
        type: 'download',
        status: EXECUTION_STATUSES.SUCCEEDED,
        description: 'Download firmware package from CDN',
      },
      {
        stepId: 2,
        name: 'Apply Update',
        type: 'apply',
        status: EXECUTION_STATUSES.CANCELED,
        description: 'Apply firmware update and reboot edge controller',
      },
    ],
    definition: {
      taskId: '550e8400-e29b-41d4-a716-446655440006',
      name: 'v5.63.5',
      type: 'FW_UPDATE',
      targetEdgeControllerId: 'EC-HW-2024-006-Z',
      metadata: {
        version: '5.63.5',
        releaseNotes: 'Hotfix for connection stability issues',
      },
      actions: [
        {
          type: 'download_firmware',
          parameters: {
            firmwareUrl: 'https://cdn.example.com/fw/v5.63.5.bin',
            checksum: 'sha256:def456...',
          },
        },
        {
          type: 'apply_firmware',
          parameters: {
            rebootAfter: true,
            timeout: 600,
          },
        },
      ],
    },
  },
];
